import React from 'react'
import { Tbody as ChakraTbody, TableBodyProps } from '@chakra-ui/table'

export const Tbody: React.FC<TableBodyProps> = ({ children, ...props }) => {
  return <ChakraTbody {...props}>{children}</ChakraTbody>
}
